'use client';

import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { TOAST_REQUESTED_EVENT, wasToastRequested } from '@/core/utils/toast';

const Toaster = dynamic(() => import('./toaster').then((m) => m.Toaster), { ssr: false });

/**
 * The storefront's <Toaster>, mounted only once something wants to show a toast (see
 * core/utils/toast.ts). `dynamic(..., { ssr: false })` alone still fetched sonner (~33 KB minified)
 * right after hydration on every page view — inside the window mobile PageSpeed counts against LCP —
 * although most visits never show a toast.
 */
export function ToasterLazy() {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        if (wasToastRequested()) {
            setMounted(true);
            return;
        }
        const mount = () => setMounted(true);
        window.addEventListener(TOAST_REQUESTED_EVENT, mount, { once: true });
        return () => window.removeEventListener(TOAST_REQUESTED_EVENT, mount);
    }, []);

    return mounted ? <Toaster /> : null;
}
